import { API_URL } from './environment';
import ky, { isHTTPError, type BeforeErrorState } from 'ky';

export const api = ky.create({
  prefix: API_URL,
  credentials: 'include',
  timeout: 30_000,
  hooks: {
    beforeError: [
      async ({ request, error }: BeforeErrorState) => {
        const response = isHTTPError(error) ? error.response : undefined;
        console.group(`🔴 API Error — ${request.method} ${request.url}`);
        console.error('Status:', response?.status, response?.statusText);
        if (response) {
          try {
            const body = (await response.clone().json()) as { detail?: string };
            console.error('Response body:', body);
            if (body?.detail) {
              error.message = body.detail;
            }
          } catch {
            try {
              const text = await response.clone().text();
              if (text) console.error('Response body:', text);
            } catch {
              // response already consumed
            }
          }
        }
        console.groupEnd();
        return error;
      },
    ],
  },
});
